import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Icon } from '@/components/ui/icon';
import { Loading03Icon } from '@/components/ui/icon/glyphs';

export function FundingProviderLoading(): ReactNode {
  const t = useTranslations('onramp');
  return (
    <output
      aria-label={t('checking_methods')}
      aria-busy="true"
      className="flex h-145 w-full items-center justify-center bg-background-primary"
    >
      <Icon icon={Loading03Icon} className="size-icon-lg animate-spin motion-reduce:animate-none" />
    </output>
  );
}
